export const initBtnUp = function() {
  //   Кнопка ВВЕРХ START
  const btnUp = document.querySelector('[data-page-up]');
  if (btnUp) {
    window.addEventListener('scroll', () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 200) {
        btnUp.classList.remove('is-hide');
      } else {
        btnUp.classList.add('is-hide');
      }
    });

    btnUp.addEventListener('click', (e) => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    });
  }
  // Кнопка ВВЕРХ END
};
